import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/AvatarSelection/AvatarSelection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/BottomSheet/BottomSheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/Input/Input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/ListSelection/ListSelection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/Modal/Modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/Search/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/design-system/src/components/molecules/Select/Select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailAppCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailHeroMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailLanguageLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailRelatedCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailRichText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/domains/core/post/components/detail/PostDetailShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppInstallBanner"] */ "/vercel/path0/src/shared/ui/AppInstallBanner/AppInstallBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/shared/ui/AppStoreLinks/AppStoreLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DragScrollRow"] */ "/vercel/path0/src/shared/ui/DragScrollRow/DragScrollRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useDragScroll"] */ "/vercel/path0/src/shared/ui/DragScrollRow/useDragScroll.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ImageBanner"] */ "/vercel/path0/src/shared/ui/ImageBanner/ImageBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptionSheet"] */ "/vercel/path0/src/shared/ui/OptionSheet/OptionSheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/shared/ui/ReadingProgress/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","REVEAL_STAGGER"] */ "/vercel/path0/src/shared/ui/Reveal/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/shared/ui/Reveal/RevealText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useParallax"] */ "/vercel/path0/src/shared/ui/Reveal/useParallax.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useProseReveal"] */ "/vercel/path0/src/shared/ui/Reveal/useProseReveal.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/shared/ui/ShareButton/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/vercel/path0/src/shared/ui/Slider/Slider.tsx");
